<template>
    <div class="paper-root">
        <div
            v-if="header"
            class="pl-3 d-flex align-items-center justify-content-between"
            :class="{
                'py-2': !tall && !noHeaderPadding,
                'py-3': (tall || !tall) && !noHeaderPadding,
                'pr-3': !noHeaderPadding,
            }"
        >
            <h6
                class="subtitle bold heading mb-0"
                :style="{
                    'max-width': restrictHeaderWidth ? '90%' : null,
                    'margin-left': offsetHeaderFromLeft ? '50px' : 'none',
                }"
            >
                {{ header.toUpperCase() }}
            </h6>
            <slot name="header" />
        </div>
        <Divider v-if="header" />

        <div
            v-if="padding || custom_padding"
            :class="
                `${
                    custom_padding != ''
                        ? custom_padding
                        : 'p-' + (shouldUseDefaultPadding ? '2' : padding)
                } w-100`
            "
        >
            <slot />
        </div>

        <slot v-else />
    </div>
</template>

<script>
export default {
    name: 'Paper',
    props: {
        header: String,
        noHeaderPadding: Boolean,
        info: {
            // Allows for displaying text on the right side of the header
            type: String,
            optional: true,
        },
        restrictHeaderWidth: Boolean,
        offsetHeaderFromLeft: Boolean,
        padding: {
            type: [Boolean, String],
            default: false,
        },
        custom_padding: {
            type: String,
            default: '',
        },
        tall: Boolean, // If the header should have more padding in the y-direction
    },
    computed: {
        shouldUseDefaultPadding() {
            return typeof this.padding === 'boolean';
        },
    },
};
</script>

<style scoped>
.paper-root {
    background-color: white;
    box-shadow: var(--shadow) !important;
    border-radius: var(--border-radius);
}
.heading {
    letter-spacing: 1px;
    font-size: 0.7rem;
    font-weight: 600 !important;
}
</style>
